import { ShieldOffIcon } from './ShieldOffIcon';

/**
 * author: Michael Richins
 * id BC537F52-4A49-433B-A031-5C698A234A35
 * name shield-off
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-off.svg
 * tags
 */
export const SecurityOffIcon = ShieldOffIcon;
export default SecurityOffIcon